import { usePopover as i } from "../../Popover/hooks/usePopover.js";
const c = (n, s) => {
  const t = i(), [e, l] = u(n, s, t);
  return l && (t == null || t.setHasInnerRole(!0)), e;
}, u = (n, s, t) => {
  if ((t == null ? void 0 : t.type) === "listbox" || (t == null ? void 0 : t.type) === "menu")
    return [t.type, !0];
  let e = s ?? "list";
  return n ? e = "listbox" : s === "nav" && (e = "list"), [e, !1];
};
export {
  c as useMenuRole
};
